export default function PosterArtwork({ artwork, compact = false }) {
  const titleLines = (artwork?.title || "视觉\n提案").split("\n");

  return (
    <div
      className={`poster-artwork poster-${artwork?.theme || "cobalt"}${compact ? " compact" : ""}`}
    >
      <span className="poster-orbit" />
      <span className="poster-grid-mark">＋</span>
      <div className="poster-topline">
        <span>{artwork?.eyebrow || "GRAPHIC DESIGN"}</span>
        <span>{artwork?.code || "图π"}</span>
      </div>
      <div className="poster-title" aria-label={titleLines.join("")}>
        {titleLines.map((line) => (
          <span key={line}>{line}</span>
        ))}
      </div>
      <div className="poster-bottomline">
        <span>{artwork?.subtitle || "DESIGN CASE"}</span>
        <span>图π / DESIGN</span>
      </div>
    </div>
  );
}
